import {
  createDispatcher,
  createSolutoEnterprisePlugin,
  MxAnalyticsDispatcher,
  updateIdentity,
} from '@soluto-private/myasurion-analytics';

const eipScope = createSolutoEnterprisePlugin({
  eipApiKey: process.env.EIP_API_KEY,
  eipApiUrl: process.env.EIP_API_URL,
});

const packageName = '@soluto-private/persona-v2';
const friendlyName = 'AsurionID';
const isLowerEnv = process.env.ENVIRONMENT_NAME !== 'production';

let dispatcher: MxAnalyticsDispatcher<void>;

export const AnalyticsClient = {
  get dispatcher() {
    if (!dispatcher) {
      dispatcher = createDispatcher(
        {
          packageName,
          friendlyName,
          dev: isLowerEnv,
          skipBuffer: true,
        },
        [eipScope],
      );
    }
    return dispatcher;
  },
  updateSession(sessionId: string) {
    updateIdentity('SessionId', sessionId);
  },
};
